class RafManager {
  constructor() {
        this.running = false;
        this._raf = null;
        this._listeners = [];

        this._date = Date.now();
        this._delta = 0;
        this._time = 0;

        window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
        window.cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;

        bindAll(this, [
            '_update'
        ]);
    }

    start() {
        this.running = true;
        this._raf = requestAnimationFrame(this._update);
    }

    stop() {
        this.running = false;
        cancelAnimationFrame(this._raf);
    }

    on(listener) {
        if (this._listeners.length === 0)
            this.start();

        this._listeners.push(listener);
    }

    off(listener) {
        const index = this._listeners.indexOf(listener);
        if (index !== -1)
            this._listeners.splice(index, 1);

        if (this._listeners.length === 0)
            this.stop();
    }

    _update() {
        this._delta = Date.now() - this._date;
        this._date = Date.now();
        this._time += this._delta / 1000;

        if (this.running) {
            for (let listener of this._listeners) {
                listener.call(listener, this._delta, this._time);
            }

            this._raf = requestAnimationFrame(this._update);
        }
    }
}

export default new RafManager();



// WEBPACK FOOTER //
// ./src/js/helpers/raf-manager.js